import * as React from 'react';
import {enhance} from './enhancer';
import {NewsForm} from './../../../components/News';
import {setState} from './stete';
import {lifecycle} from './lifecycle';
import {handler} from './handler';

function Edit(props: any) {
  const state = setState();
  lifecycle.componentDidMount(props);

  return (
    <div className="a__news-edit">
      <div className="b__title c__after-title">
        <h1>通知を編集する</h1>
      </div>
      <div className="b__form">
        <NewsForm edit {...{...props, ...state, ...handler}} />
      </div>
    </div>
  );
}

export default enhance((props: any) => <Edit {...props} />);
